import { News } from "@components/@page/internal/settings/news-setting/type";
import axiosInstanceAuth, { httpHeader } from "@components/axiosInstances";
import { buildUrlParams } from "utils/params";

const URL_AUTH = {
    GET_NEWS_BANNER: '/api/news/active/list',
}

const GetNewsBanner = async () => {
    try {
        const url = URL_AUTH.GET_NEWS_BANNER;
        const response = await axiosInstanceAuth.get(`${url}`);
        return response.data.data as News[];
    } catch (error) {
        throw error
    }
}

export { GetNewsBanner };